import script from "./OportunidadesMargen.vue?vue&type=script&setup=true&lang=js"
export * from "./OportunidadesMargen.vue?vue&type=script&setup=true&lang=js"

import "./OportunidadesMargen.vue?vue&type=style&index=0&id=f12a229e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f12a229e"]])

export default __exports__